import { PluginCategories } from '@makyoapp/makyo-sdk/models/Plugins'

import { useGetPluginForm, useGetPlugins } from '@/resolvers/plugin/query'
import { useAppClientContext } from '@/context/__project__/AppClientContext'

export const useAuthPlugin = () => {
  const { appID } = useAppClientContext()

  // get auth plugins
  const { data: authPluginsData, isLoading: isAuthPluginsLoading } = useGetPlugins({
    categories: [PluginCategories.Authentication],
  })
  const authPlugin = authPluginsData?._Data.find((p) => p._Active)

  // get auth plugin form
  const { data: authPluginFormData, isLoading: isAuthPluginFormLoading } = useGetPluginForm(appID)
  const authForm = authPluginFormData

  return {
    authPlugin,
    authForm,
    isLoadingAuthPlugin: isAuthPluginsLoading || isAuthPluginFormLoading,
  }
}
